// Multi-Entity & Multi-Currency API helper.
// Endpoints under /api/finance/entities, /api/finance/exchange-rates,
// /api/finance/intercompany, /api/finance/shared-services, /api/finance/fx-revaluation.
import axios from '../../../utils/axiosInstance';

const BASE = '/api/finance';

// ===== Entities =====
export const listEntities = (params = {}) => axios.get(`${BASE}/entities`, { params });
export const getEntity = (id) => axios.get(`${BASE}/entities/${id}`);
export const createEntity = (body) => axios.post(`${BASE}/entities`, body);
export const updateEntity = (id, body) => axios.put(`${BASE}/entities/${id}`, body);
export const deleteEntity = (id) => axios.delete(`${BASE}/entities/${id}`);
export const entityHierarchy = () => axios.get(`${BASE}/entities/hierarchy`);
export const entitiesSummary = () => axios.get(`${BASE}/entities/summary`);

// ===== Elimination Rules =====
export const listEliminationRules = () => axios.get(`${BASE}/elimination-rules`);
export const createEliminationRule = (body) => axios.post(`${BASE}/elimination-rules`, body);
export const updateEliminationRule = (id, body) => axios.put(`${BASE}/elimination-rules/${id}`, body);
export const deleteEliminationRule = (id) => axios.delete(`${BASE}/elimination-rules/${id}`);

// ===== Consolidation =====
export const runConsolidation = (body) => axios.post(`${BASE}/consolidation/run`, body);
export const listConsolidationRuns = (params = {}) => axios.get(`${BASE}/consolidation/runs`, { params });
export const getConsolidationRun = (id) => axios.get(`${BASE}/consolidation/runs/${id}`);

// ===== Exchange Rates =====
export const listExchangeRates = (params = {}) => axios.get(`${BASE}/exchange-rates`, { params });
export const latestRate = (params) => axios.get(`${BASE}/exchange-rates/latest`, { params });
export const createRate = (body) => axios.post(`${BASE}/exchange-rates`, body);
export const bulkImportRates = (rates) => axios.post(`${BASE}/exchange-rates/bulk`, { rates });
export const deleteRate = (id) => axios.delete(`${BASE}/exchange-rates/${id}`);
export const rateSummary = () => axios.get(`${BASE}/exchange-rates/summary`);

// ===== FX Revaluation =====
export const runFxRevaluation = (body) => axios.post(`${BASE}/fx-revaluation/run`, body);
export const listFxRevaluations = (params = {}) => axios.get(`${BASE}/fx-revaluation`, { params });
export const postFxRevaluation = (id) => axios.post(`${BASE}/fx-revaluation/${id}/post`);

// ===== Intercompany =====
export const listICTxns = (params = {}) => axios.get(`${BASE}/intercompany/txns`, { params });
export const getICTxn = (id) => axios.get(`${BASE}/intercompany/txns/${id}`);
export const createICTxn = (body) => axios.post(`${BASE}/intercompany/txns`, body);
export const updateICTxn = (id, body) => axios.put(`${BASE}/intercompany/txns/${id}`, body);
export const postICTxn = (id) => axios.post(`${BASE}/intercompany/txns/${id}/post`);
export const matchICTxns = (body = {}) => axios.post(`${BASE}/intercompany/match`, body);
export const markMatched = (body) => axios.post(`${BASE}/intercompany/mark-matched`, body);

// ===== Shared Services =====
export const listAllocations = (params = {}) => axios.get(`${BASE}/shared-services/allocations`, { params });
export const createAllocation = (body) => axios.post(`${BASE}/shared-services/allocations`, body);
export const postAllocation = (id) => axios.post(`${BASE}/shared-services/allocations/${id}/post`);
export const reverseAllocation = (id) => axios.post(`${BASE}/shared-services/allocations/${id}/reverse`);
